module.exports = __webpack_public_path__ + "static/media/SpaceCasinoLogo.04cbb4e5.zip";